import { useMutation, useQueryClient } from "@tanstack/react-query";
import React from "react";
import { Link } from "react-router-dom";
import RoleApi from "../api/manageRoleApi";
import { toast } from "react-toastify";
import { setFetchRoleData } from "../../../../core/data/redux/authSlice";
import { useDispatch } from "react-redux";
import { handleModalAction } from "../../../../utils/helpers/handleModalAction";
import { useFormik } from "formik";
import * as Yup from "yup";

const AddRoleModal = () => {
  const roleNameArr = JSON.parse(localStorage.getItem("roleNameArr")) || [];
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  const mutationAddRole = useMutation({
    mutationFn: RoleApi.addRole,
    onSuccess: () => {
      queryClient.invalidateQueries(["roles"]);
      dispatch(setFetchRoleData());
      toast.success("Role added successfully.");
      formik.resetForm();
      handleModalAction("add_role", "hide");
    },
    onError: (error) => {
      toast.error(error.response?.data?.msg || "Failed to add role.");
    },
  });

  const formik = useFormik({
    initialValues: {
      name: "",
      parentRoleId: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Role name is required."),
      parentRoleId: Yup.string().required("Reports to is required."),
    }),
    onSubmit: (values) => {
      const updatedRoleData = {
        name: values.name,
        parentRole: values.parentRoleId || null,
      };
      mutationAddRole.mutate(updatedRoleData);
    },
  });

  return (
    <div className="modal fade" id="add_role" role="dialog">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Add Role</h5>
            <Link to="#" className="btn btn-light me-2" data-bs-dismiss="modal">
              <i className="ti ti-x" />
            </Link>
          </div>
          <form onSubmit={formik.handleSubmit}>
            <div className="modal-body">
              <div className="mb-3">
                <label className="col-form-label">
                  Role Name<span className="text-danger">*</span>
                </label>
                <input
                  className="form-control text-capitalize"
                  name="name"
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder="Enter Role Name"
                />
                {formik.touched.name && formik.errors.name ? (
                  <div className="text-danger">{formik.errors.name}</div>
                ) : null}
              </div>
              <div className="mb-3">
                <label className="col-form-label">
                  Reports To<span className="text-danger">*</span>
                </label>
                <select
                  id="parentRoleId"
                  className="form-select"
                  name="parentRoleId"
                  value={formik.values.parentRoleId}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  <option value="" disabled>
                    -None-
                  </option>
                  {roleNameArr.map((role, index) => (
                    <option key={index} value={role.value}>
                      {role.label}
                    </option>
                  ))}
                </select>
                {formik.touched.parentRoleId && formik.errors.parentRoleId ? (
                  <div className="text-danger">
                    {formik.errors.parentRoleId}
                  </div>
                ) : null}
              </div>
            </div>
            <div className="modal-footer">
              <div className="d-flex align-items-center justify-content-end m-0">
                <Link
                  to="#"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </Link>
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={mutationAddRole.isPending}
                >
                  {mutationAddRole.isPending ? "Creating..." : "Create"}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddRoleModal;
